import { Button, Form, Grid, Input, Select } from 'antd';
import { ContentFilters } from 'components';
import { StandardItemsWrapper } from 'components/content-filters/content-filters.styles';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { discoverFilterFormField, DiscoverFilterFormValues } from './types';


const { useBreakpoint } = Grid;

type EventsFilterFormProps = {
  formId: string;
  handleFilter: (values: DiscoverFilterFormValues) => void;
  initialValues: DiscoverFilterFormValues;
  closeModal?: () => void;
};

export const DiscoverFilterForm = ({
  formId,
  handleFilter,
  initialValues,
  closeModal,
}: EventsFilterFormProps) => {
  const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
  const [form] = Form.useForm<DiscoverFilterFormValues>();
  const { t } = useTranslation();
  const screens = useBreakpoint();

  const onReset = () => {
    form.resetFields();
    handleFilter({ ...initialValues })
  };

  const handleOnFinish = (values: DiscoverFilterFormValues) => {
    handleFilter(values);
    closeModal?.();
  };
  const status = [
    {
      label: true,
      name: 'Active',
    },
    {
      label: false,
      name: 'InActive',
    },
  ];
  const status_value = status.map((res) => ({
    value: res.label,
    label: res.name,
  }));

  return (
    <Form<DiscoverFilterFormValues>
      id={formId}
      name={formId}
      form={form}
      layout='vertical'
      onFinish={handleOnFinish}
      initialValues={initialValues}
      onFinishFailed={() => {
        setValidateTrigger(['onChange']);
      }}
      validateTrigger={validateTrigger}
    >
      <ContentFilters.FormItemsWrapper style={{ width: '100%' }}>
        <StandardItemsWrapper style={{ width: '100%' }}>
          <div className='invoice_list' style={{ width: '100%' }}>
            <Form.Item<DiscoverFilterFormValues>
              label={'Title'}
              name={discoverFilterFormField.TITLE}
            >
              <Input placeholder={t('events.formEvents.name.placeholder')} />
            </Form.Item>
            <Form.Item<DiscoverFilterFormValues>
              label={'Status'}
              name={discoverFilterFormField.ACTIVE}
            >
              <Select
                defaultValue="Select status"

                options={status_value}
              />
            </Form.Item>
            {screens.lg && (
              <ContentFilters.ButtonsWrapper className='filter_btn'>
                <Button type='primary' htmlType='submit'>
                  {t('events.buttons.filter', { count: 1 })}
                </Button>
                <Button onClick={onReset}>{t('events.buttons.reset')}</Button>
              </ContentFilters.ButtonsWrapper>
            )}
          </div>

        </StandardItemsWrapper>
      </ContentFilters.FormItemsWrapper>


    </Form>
  );
};
